module.exports = __webpack_public_path__ + "img/nrb-cover.c5bcdebf.png";